// extracted by mini-css-extract-plugin
export default {"container":"StatIcon_container__A0I+5","rating":"StatIcon_rating__Ajxfp","icon":"StatIcon_icon__ZhNCu"};